module.exports = __webpack_public_path__ + "img/games-7.b5bd3f5e.jpg";